import { createSagas, bootSagas } from 'helpers/hotelModuleHelper';
import { actions, actionTypes } from '../actions/hotelNewsletter';
import { selectors, DEFAULT_STATE } from '../reducers/hotelNewsletter';
import api from '../apis/hotelNewsletter';

const sagas = createSagas(
    'hotelNewsletter',
    actionTypes,
    actions,
    api,
    selectors,
    DEFAULT_STATE
);

const defaultSagas = bootSagas(sagas, actionTypes);

export default [...defaultSagas];
